import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiShield, FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { login } from '../services/api';
import { useLanguage } from '../i18n/LanguageContext';

const Login = () => {
  const { t, language, setLanguage } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(email, password);
      localStorage.setItem('token', res.data.token);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.error || t('loginError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <FiShield className="text-blue-500 text-4xl" />
            <h1 className="text-white text-3xl font-bold">BrickManager</h1>
          </div>
          <div className="flex gap-2">
            <button onClick={() => setLanguage('en')}
              className={`px-3 py-1 rounded-lg text-sm font-semibold ${language === 'en' ? 'bg-blue-600 text-white' : 'bg-slate-700 text-slate-400'}`}>
              EN
            </button>
            <button onClick={() => setLanguage('uk')}
              className={`px-3 py-1 rounded-lg text-sm font-semibold ${language === 'uk' ? 'bg-blue-600 text-white' : 'bg-slate-700 text-slate-400'}`}>
              UA
            </button>
          </div>
        </div>

        <div className="bg-slate-800 rounded-2xl p-8 shadow-xl">
          <h2 className="text-white text-2xl font-semibold mb-6">{t('login')}</h2>
          {error && (
            <div className="bg-red-500/10 border border-red-500 text-red-400 px-4 py-3 rounded-lg mb-6">{error}</div>
          )}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-slate-400 text-sm mb-2 block">{t('email')}</label>
              <div className="relative">
                <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-slate-700 text-white pl-10 pr-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="email@example.com" required />
              </div>
            </div>
            <div>
              <label className="text-slate-400 text-sm mb-2 block">{t('password')}</label>
              <div className="relative">
                <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input type={showPassword ? 'text' : 'password'} value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-slate-700 text-white pl-10 pr-10 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="••••••••" required />
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white">
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 text-white py-3 rounded-lg font-semibold transition-colors">
              {loading ? '...' : t('loginBtn')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
